import { put, takeLatest } from "redux-saga/effects";
import {
  INVEST_FUND,
  INVEST_FUND_FAILED,
  INVEST_FUND_INIT,
  INVEST_FUND_SUCCESS,
} from "./constants";
import { getUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";

export function* investFund({ payload }) {
  yield put({ type: INVEST_FUND_INIT });
  try {
    let url = `${API.InvestedFund}?Keyword=${payload.keyword}&Page=${payload.page}&PerPage=${payload.limit}`;
    if (payload.strategy) {
      url = `${url}&StrategyId=${payload.strategy}`;
    }
    const res = yield getUtil(url);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: INVEST_FUND_SUCCESS, payload: data.result });
    } else {
      yield put({ type: INVEST_FUND_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getinvestfund() {
  yield takeLatest(INVEST_FUND, investFund);
}
